import React from 'react';
import Select from 'react-select';
import _ from 'lodash';
import Spin from '../../commonModules/interface/Spin';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getReports, updateReport } from '../../../../../jsx/actions/reportAction';
import { getPaygClients } from '../../../../../jsx/actions/clientAction';
import { fetchSubscriptions } from '../../../../../jsx/actions/subscriptionAction';
import ReportsList from './Reports/ReportsList.jsx';
import { Card, CardHeader, Box, AppBar, Tabs, Tab } from '@material-ui/core';
import CardPage from '../../commonModules/layouts/CardPage';

class Reports extends React.Component {
    state = {
        headerMenu: 0,
        select: false,
        boxList: this.props.CLIENTS,
        reportIDList: [],
        filteredList: null,
        status: 'Tous',
        currentBox: null,
        currentPage: 0,
        rowsPerPage: 20,
    };
    async componentWillMount() {
        try {
            // getClientReports()
            if(!this.props.STATE.paygClients.fetched){
            // if(!this.props.CLIENTS){
                await this.props.getClients()
            }
            if(!this.props.REPORTS){
                await this.props.getReports()
            }
            if (!this.props.SUBSCRIPTIONS){
                this.props.fetchSubscriptions()         
            }
            
            this.filter()
        } catch (err) {
            console.log(err);
        }
    }
    filter = (status = this.state.status) => {
        const { REPORTS } = this.props
        const { currentBox } = this.state;
        let filteredList = {};
        console.log('STATUS : ', status, ' currentBox : ', currentBox);

        if (status === 'Tous') {
            if (currentBox) {
                console.log('Tous + ', currentBox, ' REPORTS : ', REPORTS);
                Object.values(REPORTS).map( report => {
                    if (report.boxAssoId === currentBox) {
                        filteredList = {...filteredList, [report.id]:report};
                    }
                });
            } else {
                filteredList = REPORTS;
            }
            console.log('if TOUS : ', filteredList);
        } else {
            Object.values(REPORTS).map( report => {
                console.log('status : ', status, ' report STATUS : ', report.labels[report.labels.length - 1].val, 'currentBox : ', currentBox, ' report BOX ID : ', report.boxAssoId);

                let lastLabel = report.labels[report.labels.length - 1].val
                if(lastLabel === "Visite recouvrement en attente" || lastLabel === "Désinstallation en attente"){
                    lastLabel = "En attente"
                }

                if ( lastLabel === status) {
                    if (currentBox && report.boxAssoId === currentBox) {
                        filteredList = {...filteredList, [report.id]:report};
                    } else if (!currentBox) {
                        filteredList = {...filteredList, [report.id]:report};
                    }
                }
            });
        }
        this.setState({ filteredList, reportIDList: Object.keys(filteredList), currentPage: 0, status });
    }
    // onChangeTab = (e, status) => {
    //     this.setState({
    //         status,
    //         currentPage: 0,
    //     })
    //     this.filter()
    // }
    onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        this.setState({ pageOfItems, currentPage, rowsPerPage });
    }
    render() {
        console.log("[STATE] ReportList", this.state);
        
        const { CLIENTS, REPORTS } = this.props;
        console.log('BOX LIST : ', this.state.boxList , ` [${this.state.currentBox}]`);

        let boxList = [{ value: null, label: '' }];
        if (CLIENTS) {
            Object.values(CLIENTS).map(client => {
                if(client.reports && client.resume){
                    boxList = [
                        ...boxList, 
                        { value: client.resume.boxAssoId, label: `${client.resume.idBox} - ${client.resume.clientName}` }
                    ];
                }
            });
        }
        return (
            <CardPage
                title="Liste des pannes"
                subtitle="Liste des pannes par statut / Paygo ID"
            >
                <Card>
                    <AppBar position="static">
                        <Tabs
                            value={this.state.status}
                            onChange={(e, status) => this.filter(status)}
                            // onChange={this.onChangeTab}
                            indicatorColor="secondary"
                            textColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab value="Tous" label="Tous" />
                            <Tab value="En attente" label="En attente" />
                            <Tab value="En cours de traitement" label="En cours de traitement" />
                            <Tab value="En attente de validation" label="En attente de validation" />
                            <Tab value="standby" label="Stand By" />
                            <Tab value="Résolu" label="Résolu" />
                        </Tabs>
                    </AppBar>
                    <Box p={2}>
                        <Box p={1}>
                            <Select
                                options={boxList}
                                className="form-control"
                                value={this.state.currentBoxDisplay}
                                placeholder="Select a box ID"
                                onChange={(option) => this.setState({ currentBox: option.value, currentBoxDisplay:option }, this.filter) }
                                style={{border: '0'}}
                                selectedValue={this.state.currentBoxDisplay}
                                // Le tableau en dessous est en stickyHeader (MUI : z-index 2) ;
                                // le menu react-select (z-index 1) passait derrière l'en-tête.
                                styles={{ menu: (base) => ({ ...base, zIndex: 3 }) }}
                            />
                        </Box>

                        {/* { !_.isEmpty(this.state.filteredList) && */}
                        <ReportsList
                            paygoID={this.state.currentBox}
                            reportIDList={this.state.reportIDList}
                            filterFct={this.filter}
                            REPORTS={this.props.REPORTS}
                            updateReport={this.props.updateReport}
                            onChangePage={this.onChangePage}
                            currentPage={this.state.currentPage}
                            rowsPerPage={this.state.rowsPerPage}
                            {...this.props}
                        />
                        {/* } */}
                        
                        { _.isNull(this.state.filteredList) &&
                        // <h4 style={{ paddingBottom: '1.5rem', textAlign: 'center' }}>Récupération des pannes...</h4>
                            <Spin noOverlay={true}/>
                        }
                        </Box>
                </Card>   
            </CardPage>
        );
    }
}

function mapStateToProps(state){
    return {
        REPORTS: state.reports,
        CLIENTS: state.clients,
        STATE: state.inventory.requestState,
        SUBSCRIPTIONS: state.subscriptions
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getReports: getReports,
        getClients: getPaygClients,
        fetchSubscriptions: fetchSubscriptions,
        updateReport: updateReport,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)